module.exports = __webpack_public_path__ + "img/marker-point-gris.000870cb.png";